<template>
<svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <!-- <symbol id="icon-alert-circle" viewBox="0 0 24 24">
          <title>alert-circle</title>
          <path d="M12 1c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM12 21c-5 0-9-4-9-9s4-9 9-9c5 0 9 4 9 9s-4 9-9 9z"></path>
          <path d="M12 7c-0.6 0-1 0.4-1 1v4c0 0.6 0.4 1 1 1s1-0.4 1-1v-4c0-0.6-0.4-1-1-1z"></path>
          <path d="M11.3 15.3c-0.2 0.2-0.3 0.4-0.3 0.7s0.1 0.5 0.3 0.7c0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.2-0.2 0.3-0.5 0.3-0.7s-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4 0z"></path>
      </symbol> -->
      <symbol id="icon-station-warning" viewBox="0 0 24 24">
          <title>alert-warning</title>
          <path d="M23 17.5l-8.4-14.2c-0.4-0.7-1.1-1.2-1.9-1.4s-1.6-0.1-2.3 0.3c-0.4 0.2-0.8 0.6-1 1 0 0 0 0 0 0l-8.4 14.3c-0.8 1.4-0.3 3.3 1.1 4.1 0.4 0.3 0.9 0.4 1.4 0.4h17c0.8 0 1.6-0.3 2.1-0.9 0.6-0.6 0.9-1.3 0.9-2.1-0.1-0.5-0.2-1.1-0.5-1.5zM21.2 19.7c-0.2 0.2-0.5 0.3-0.7 0.3h-17c-0.2 0-0.3 0-0.5-0.1-0.5-0.3-0.6-0.9-0.4-1.4l8.5-14.1c0.1-0.1 0.2-0.3 0.3-0.3 0.5-0.3 1.1-0.1 1.4 0.3l8.5 14.1c0.1 0.1 0.1 0.3 0.1 0.5 0.1 0.3-0.1 0.5-0.2 0.7z"></path>
          <path d="M12 8c-0.6 0-1 0.4-1 1v4c0 0.6 0.4 1 1 1s1-0.4 1-1v-4c0-0.6-0.4-1-1-1z"></path>
          <path d="M11.3 16.3c-0.2 0.2-0.3 0.4-0.3 0.7s0.1 0.5 0.3 0.7c0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.2-0.2 0.3-0.5 0.3-0.7s-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4 0z"></path>
      </symbol>
      <symbol id="icon-station-arrow" viewBox="0 0 11 8">
          <title>station-arrow</title>
          <polygon points="10.5,0.5 5.5,4.5 0.5,0.5 0.5,3.5 5.5,7.5 10.5,3.5 "/>
      </symbol>
      <symbol id="icon-station-easy" viewBox="0 0 12 10">
          <title>station-easy</title>
          <path style="fill-opacity:inherit;fill:inherit;enable-background:new;" d="M4.5.5h4v2h-4zM2.5 4.5h8v2h-8z"/>
          <path style="fill-opacity:1;fill:#00FFBC;" d="M.5 8.5h12v2H.5z"/>
      </symbol>
      <symbol id="icon-station-medium" viewBox="0 0 12 10">
          <title>station-medium</title>
          <path style="fill-opacity:inherit;fill:inherit;enable-background:new;" d="M4.5.5h4v2h-4z"/>
          <path style="fill-opacity:1;fill:#00FFBC;" d="M2.5 4.5h8v2h-8zM.5 8.5h12v2H.5z"/>
      </symbol>
      <symbol id="icon-station-hard" viewBox="0 0 12 10">
          <title>station-hard</title>
          <path style="fill-opacity:1;fill:#00FFBC;" d="M4.5.5h4v2h-4zM2.5 4.5h8v2h-8zM.5 8.5h12v2H.5z"/>
      </symbol>
      <symbol id="icon-station-singleplayer" viewBox="0 0 11 11">
          <title>station-singleplayer</title>
          <circle cx="5.5" cy="3" r="2.5"/>
          <path d="M5.5 6.7c-3.8 0-5 2.5-5 2.5v1.3h10V9.3s-1.2-2.6-5-2.6z"/>
      </symbol>
      <symbol id="icon-station-multiplayer" viewBox="0 0 15 11">
          <title>station-multiplayer</title>
          <path d="M4.6.5C3.4.5 2.4 1.6 2.4 2.9s1 2.4 2.3 2.4C5.9 5.2 7 4.2 7 2.9 6.9 1.6 5.8.5 4.6.5zM10.3.5C9.1.5 8.1 1.6 8.1 2.9s1 2.4 2.3 2.4c1.2 0 2.3-1.1 2.3-2.4-.1-1.3-1.1-2.4-2.4-2.4zM4.6 6.5C1.5 6.5.5 9.1.5 9.1v1.3h8.2V9.1s-1-2.6-4.1-2.6zM10.3 6.5c-1 0-1.7.2-2.3.5.9.8 1.3 1.7 1.3 1.8l.1.2v1.5h5.1V9.1c-.1 0-1.1-2.6-4.2-2.6z"/>
      </symbol>
      <symbol id="icon-station-search" viewBox="0 0 67 67">
          <title>station-search</title>
          <path id="Shape" d="M23.5,0C10.4,0,0,10.4,0,23.5s10.4,23.5,23.5,23.5c5.8,0,11-2.1,15.1-5.4l1.7,1.7v2.7L61.3,67
          	l5.7-5.7L45.9,40.2h-2.9l-1.6-1.6c3.4-4.1,5.5-9.4,5.5-15.2C46.9,10.4,36.5,0,23.5,0z M23.5,6.7c9.4,0,16.8,7.4,16.8,16.8
          	s-7.4,16.8-16.8,16.8S6.7,32.8,6.7,23.5S14.1,6.7,23.5,6.7z"/>
      </symbol>
      <symbol id="icon-station-no-results" viewBox="0 0 67 67">
          <title>station-no-results</title>
          <path id="Shape" d="M23.5,0C10.4,0,0,10.4,0,23.5s10.4,23.5,23.5,23.5c5.8,0,11-2.1,15.1-5.4l1.7,1.7v2.7L61.3,67
          	l5.7-5.7L45.9,40.2h-2.9l-1.6-1.6c3.4-4.1,5.5-9.4,5.5-15.2C46.9,10.4,36.5,0,23.5,0z M23.5,6.7c9.4,0,16.8,7.4,16.8,16.8
          	s-7.4,16.8-16.8,16.8S6.7,32.8,6.7,23.5S14.1,6.7,23.5,6.7z"/>
          <polygon id="Path" points="32,29.7 29.7,32 24,26.3 18.3,32 16,29.7 21.7,24 16,18.3 18.3,16 24,21.7 29.7,16 32,18.3
          	26.3,24 "/>
      </symbol>
      <symbol id="icon-station-volume-down" viewBox="0 0 20 18">
          <title>station-volume-down</title>
          <polygon points="10,0 4,6 0,6 0,12 4,12 10,18 "/>
          <path d="M12,5.1v7.7c1.7-0.4,3-1.9,3-3.8S13.7,5.6,12,5.1z"/>
      </symbol>
      <symbol id="icon-station-volume-up" viewBox="0 0 20 18">
          <title>station-volume-up</title>
          <polygon points="10,0 4,6 0,6 0,12 4,12 10,18 "/>
          <path d="M12,0.1v2c3.4,0.5,6,3.4,6,6.9s-2.6,6.4-6,6.9v2c4.5-0.5,8-4.3,8-8.9S16.5,0.6,12,0.1z"/>
          <path d="M12,5.1v7.7c1.7-0.4,3-1.9,3-3.8S13.7,5.6,12,5.1z"/>
      </symbol>
      <symbol id="icon-station-thumbs-down" viewBox="0 0 23 21">
          <title>station-thumbs-down</title>
          <path d="M9.8 20.5l6.6-6.4c.4-.4.6-.9.6-1.4V2.5c0-1.1-.9-2-2.1-2h-9c-.8 0-1.5.5-1.8 1.2L.8 8.9c-.2.4-.3.8-.3 1.3v1c0 1.1 1.1 2.1 2.2 2.1h6.6s-1.6 4.1-1.6 4.8c0 1.9 2.1 2.4 2.1 2.4zM19.2.5h3.3v12.8h-3.3z"/>
      </symbol>
      <symbol id="icon-station-thumbs-up" viewBox="0 0 23 21">
          <title>station-thumbs-up</title>
          <path d="M7.7 2.9c0 .7 1.6 4.8 1.6 4.8H2.7C1.6 7.7.5 8.7.5 9.8v1c0 .5.1.9.3 1.3l3.3 7.2c.3.7 1 1.2 1.8 1.2h9c1.2 0 2.1-.9 2.1-2V8.3c0-.5-.2-1-.6-1.4L9.8.5S7.7 1 7.7 2.9zM19.2 7.7h3.3v12.8h-3.3z"/>
      </symbol>
      <symbol id="icon-station-checkmark" viewBox="0 0 13 10">
          <title>station-checkmark</title>
          <polygon points="11.5,0 4.1,7.4 1,4.3 0,5.3 3.6,8.9 4.1,9.4 4.6,8.9 12.5,1 "/>
      </symbol>
      <symbol id="icon-station-close" viewBox="0 0 21 21">
          <title>station-close</title>
          <path d="M10.5.5C5 .5.5 5 .5 10.5s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 1.5c4.7 0 8.5 3.8 8.5 8.5S15.2 19 10.5 19 2 15.2 2 10.5 5.8 2 10.5 2zM7.6 6.5L6.5 7.6l2.9 2.9-2.9 2.9 1.1 1.1 2.9-2.9 2.9 2.9 1.1-1.1-2.9-2.9 2.9-2.9-1.1-1.1-2.9 2.9-2.9-2.9z"/>
      </symbol>
      <symbol id="icon-station-x" viewBox="0 0 24 24">
          <title>station-x</title>
          <path d="M13.4 12l5.3-5.3c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0l-5.3 5.3-5.3-5.3c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l5.3 5.3-5.3 5.3c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3l5.3-5.3 5.3 5.3c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-5.3-5.3z"></path>
      </symbol>
      <symbol id="icon-station-help" viewBox="0 0 20 20">
          <title>station-help</title>
          <path d="M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 3C7 5 7 8 7 8h2l1-1 1 1c0 2-2 1-2 4h2l2-4c0-1-1-3-3-3zm-1 8v2h2v-2H9z"/>
      </symbol>
      <symbol id="icon-station-wave" viewBox="0 0 20 20">
          <title>station-wave</title>
          <path d="M13.1 1.2l-.7.8c1.4 1.1 2.5 2.7 2.5 2.7l.9-.6c.1 0-1.2-1.7-2.7-2.9zm-3.5.1l-.6.9c2.7 2 4 4 4 4l.9-.6s-1.4-2.2-4.3-4.3zM5.9 2L5 3.2l3.8 3.5-.8.8-4.6-4.2-1 1.2 4.4 4-.6.7-4.1-3.5L1 6.8l4 3.5-.5.6-2.3-2.1L1.1 10s4.7 4.4 6.3 5.5c2 1.4 4.6 1.6 6 .5 1.4-1.1 2.4-3.1 2.9-4.1L19 6c-.7-.6-1.8-.9-3.1.4-.8.7-2.2 2.1-2.2 2.1L5.9 2zM2.7 14.4l-.7.7c1.4 1.5 3.9 3 5.8 3.7l.4-1c-1.8-.6-4.2-2.1-5.5-3.4z"/>
      </symbol>
      <symbol id="icon-station-exit" viewBox="0 0 20 20">
          <title>station-exit</title>
          <path d="M4 0L2 2v16l2 2h12l2-2v-5l-2 1v4H4V2h12v3l2 2V2l-2-2H4zm10 6v3H9v2h5v3l5-4-5-4z"/>
      </symbol>
      <symbol id="icon-station-play" viewBox="0 0 20 20">
          <title>station-play</title>
          <path d="M3 1v18l15-9z"/>
      </symbol>
      <symbol id="icon-station-language" viewBox="0 0 13 13">
          <title>station-language</title>
          <path d="M6.5,0C2.9,0,0,2.9,0,6.5S2.9,13,6.5,13S13,10.1,13,6.5S10.1,0,6.5,0z M6,1.1V3H4.6
          	c0.1-0.2,0.1-0.4,0.2-0.5C5.2,1.8,5.6,1.3,6,1.1z M7,1.1c0.4,0.2,0.8,0.6,1.2,1.3C8.3,2.6,8.3,2.8,8.4,3H7V1.1z M4.3,1.5
          	C4.2,1.7,4,1.8,3.9,2C3.8,2.3,3.6,2.7,3.5,3H2.3C2.8,2.4,3.5,1.8,4.3,1.5z M8.7,1.5c0.8,0.3,1.5,0.9,2,1.5H9.5
          	C9.4,2.7,9.2,2.3,9.1,2C9,1.8,8.8,1.7,8.7,1.5z M1.6,4h1.7C3.1,4.6,3.1,5.3,3,6H1C1.1,5.3,1.3,4.6,1.6,4z M4.3,4H6v2H4
          	C4.1,5.3,4.1,4.6,4.3,4z M7,4h1.7C8.9,4.6,8.9,5.3,9,6H7V4z M9.7,4h1.7c0.3,0.6,0.5,1.3,0.6,2h-2C9.9,5.3,9.9,4.6,9.7,4z M1,7h2
          	c0,0.7,0.1,1.4,0.2,2H1.6C1.3,8.4,1.1,7.7,1,7z M4,7h2v2H4.3C4.1,8.4,4.1,7.7,4,7z M7,7h2c0,0.7-0.1,1.4-0.3,2H7V7z M10,7h2
          	c-0.1,0.7-0.3,1.4-0.6,2H9.7C9.9,8.4,9.9,7.7,10,7z M2.3,10h1.3c0.1,0.3,0.2,0.7,0.4,1c0.1,0.2,0.2,0.4,0.3,0.6
          	C3.5,11.2,2.8,10.6,2.3,10z M4.6,10H6v1.9c-0.4-0.2-0.8-0.6-1.2-1.3C4.7,10.4,4.7,10.2,4.6,10z M7,10h1.4c-0.1,0.2-0.1,0.4-0.2,0.5
          	c-0.4,0.7-0.8,1.1-1.2,1.3V10z M9.5,10h1.3c-0.5,0.6-1.2,1.2-2,1.5C8.8,11.3,9,11.2,9.1,11C9.2,10.7,9.4,10.3,9.5,10z"/>
      </symbol>
      <filter id="svg-gaussian-blur">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
        <feOffset dx="0" dy="0" />
        <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
</svg>
</template>

<script>
export default {
}
</script>

<style >

.icon-station-easy, .icon-station-medium {
  fill-opacity:0.4;
  fill:white;
}

</style>
